import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent, useIonViewDidEnter, IonInfiniteScroll, IonInfiniteScrollContent } from '@ionic/react'
import { UseHeader, MktEmpty } from '@cps'
import { MemberApi } from '@api/index'
import { storeMobx, memberMobx } from '@mobxStore'
import { format, ddayjs } from '@dt/fe-utils'
import { each } from '@dt/fe-utils/dist/lodash'
import { useHistoryNew } from '@utils'
import mktController from 'controllers/mktController'
import './index.scss'

interface IProps extends IPage, RouteComponentProps {
}

const pageSize: number = 12

const Card: FC<IProps> = ({ match }) => {
  const history = useHistoryNew()
  // Component State
  const [page, setPage] = useState<number>(0)
  const [logs, setLogs] = useState<any[]>([])
  const [canget, setCanget] = useState<boolean>(true)
  // Data Method
  const getData = (pageNum: number, data: any[]) => {
    const allStoerId: any[] = []
    each(storeMobx.storeList, (item: any) => {
      allStoerId.push(item.storeId)
    })
    const para: any = {
      start_time: `${ddayjs().year() - 1}-${ddayjs().month() + 1}-${ddayjs().date()}`,
      end_time: ddayjs().format('YYYY-MM-DD'),
      brand_id: `${storeMobx.brand.brandId}`,
      store_id: storeMobx.info.storeId ? `${storeMobx.info.storeId}` : '0,' + allStoerId.join(','),
      member_id: `${memberMobx.memberInfo.memberId}`,
      page: pageNum,
      size: pageSize,
    }
    MemberApi.getConsumRecord(para).then((res: any) => {
      if (!res.error) {
        setLogs(data.concat(res.content))
        if (pageNum + 1 >= Math.ceil(res.info.total_cnt / pageSize)) {
          setCanget(false)
        } else {
          setCanget(true)
        }
      }
    })
  }

  const onScrollEnd = (ev: any) => {
    if (canget) {
      setTimeout(() => {
        setPage(page + 1)
        ev.target.complete()
      }, 500)
    }
  }

  useEffect(() => {
    getData(page, page === 0 ? [] : logs)
  }, [page])

  useIonViewDidEnter(() => {
    getData(0, [])
  })
  return (
    <IonPage className='consum-page'>
      <UseHeader onBack={() => mktController.goBack(history)} title={i18n.t('mkt.record.personalConsumRecords')}></UseHeader>
      <IonContent className='page-content'>
        {logs.length === 0 && <MktEmpty />}
        {logs.length >= 0 &&
          <div className='flow-table'>
            {
              logs.map((item: any, index: number) => {
                return (
                  <div key={index} className='flow-item'>
                    <div className='flow-area'>
                      <div className='flow-con title'>
                        <span className='left'>{item.store_name || '--'}</span>
                        <span>{i18n.t('mkt.record.consum')} {format.toPrice(item.paid_fee)}</span>
                      </div>
                      <div className='flow-con'>
                        <span>{item.orders_id}</span>
                        <span>{i18n.t(`mkt.record.${item.eat_type}`)}</span>
                      </div>
                      <div className='flow-con'>
                        <span>{format.toDateTime(item.pay_time)}</span>
                        <span>{item.source_type}</span>
                      </div>
                    </div>
                  </div>)
              })
            }
          </div>}
        {
          canget &&
            <IonInfiniteScroll threshold='100px' onIonInfinite={(ev) => onScrollEnd(ev)}>
              <IonInfiniteScrollContent
                loadingSpinner='bubbles'
                loadingText={i18n.t('order.loadmore')}
              >
              </IonInfiniteScrollContent>
            </IonInfiniteScroll>
        }
      </IonContent>
    </IonPage>
  )
}

export default observer(Card)
